// No imports on purpose: AutomationRunsList reads these at module load, and
// consts.ts sits in an import cycle with it (via the cells and the module
// index), so they must not depend on anything that can be mid-initialisation.

/**
 * Column ids of the runs table's fixed columns, which is how their persisted
 * widths are keyed.
 */
export const RUNS_TABLE_FIXED_COLUMN_IDS = {
  startTime: 'create_time',
  status: 'status',
  version: 'stage_version',
  trigger: 'trigger',
  inputs: 'inputs',
  /** The single "Outputs" column shown when an automation has none. */
  outputs: 'outputs-none',
  actions: 'actions',
} as const;

/** Bounds a dragged fixed (non-output) column is kept within. */
export const FIXED_COLUMN_MIN_WIDTH = 64;
export const FIXED_COLUMN_MAX_WIDTH = 600;

/** Narrowest an output column gets, whether it flexes or was dragged. */
export const OUTPUT_COLUMN_MIN_WIDTH = 200;
/** Widest a dragged output column is kept at. */
export const OUTPUT_COLUMN_MAX_WIDTH = 360;
